// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__5Ap8Q","title":"InfoRow_title__Pn8YJ"};